import LoginPage from 'views/Pages/LoginPage.jsx';
import ErrorPage from 'views/Pages/ErrorPage.jsx';
import Dashboard from 'views/Dashboard/Dashboard.jsx';
import User from 'views/User/User.jsx';
import UserPage from 'views/User/UserPage.jsx';
import Media from 'views/Media/Media.jsx';
import MediaPage from 'views/Media/MediaPage.jsx';
import Category from 'views/Category/Category.jsx';

// @material-ui/icons
// import Apps from "@material-ui/icons/Apps";
import EventBusyIcon from '@material-ui/icons/EventBusy';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DateRange from '@material-ui/icons/DateRange';
import Person from '@material-ui/icons/Person';
import Home from '@material-ui/icons/Home';

var dashRoutes = [
  {
    path: '/dashboard',
    name: 'Commercials',
    icon: DashboardIcon,
    component: Dashboard,
    layout: '/admin',
    hidden: false,
  },
  {
    path: '/dashboard/page/:id',
    name: 'Commercials',
    icon: DashboardIcon,
    component: Dashboard,
    layout: '/admin',
    hidden: true,
  },
  {
    collapse: true,
    hidden: true,
    name: 'Pages',
    icon: DateRange,
    state: 'pageCollapse',
    views: [
      {
        path: '/login-page',
        name: 'Login Page',
        component: LoginPage,
        layout: '/auth',
        hidden: true,
      },
      {
        path: '/error-page',
        name: 'Error Page',
        component: ErrorPage,
        layout: '/auth',
        hidden: true,
      },
    ],
  },
  {
    path: '/category',
    name: 'Category',
    icon: EventBusyIcon,
    component: Category,
    layout: '/admin',
    hidden: false,
  },
  {
    path: '/user',
    name: 'User',
    icon: Person,
    component: User,
    layout: '/admin',
    hidden: false,
  },
  {
    path: '/user/create',
    name: 'UserView',
    icon: Person,
    component: UserPage,
    layout: '/admin',
    hidden: true,
  },
  {
    path: '/user/:id',
    name: 'UserView',
    icon: Person,
    component: UserPage,
    layout: '/admin',
    hidden: true,
  },
  {
    path: '/user/:id/edit',
    name: 'UserView',
    icon: Person,
    component: UserPage,
    layout: '/admin',
    hidden: true,
  },
  {
    path: '/media',
    name: 'Media',
    icon: Home,
    component: Media,
    layout: '/admin',
    hidden: false,
  },
  {
    path: '/media/create',
    name: 'MediaView',
    icon: Home,
    component: MediaPage,
    layout: '/admin',
    hidden: true,
  },
  {
    path: '/media/:id/:task',
    name: 'MediaView',
    icon: Home,
    component: MediaPage,
    layout: '/admin',
    hidden: true,
  },
  // {
  //   path: '/media/:id/edit',
  //   name: 'MediaView',
  //   icon: Home,
  //   component: MediaPage,
  //   layout: '/admin',
  //   hidden: true,
  // },
];

export default dashRoutes;
